import React, {useCallback, useState} from "react";
import {Card, CardContent, Dialog} from "@mui/material";
import GameDetail from "@/view/game/GameDetail";

export interface GameListItemProps {
    game: {
        matchDt: string
        time: string
        place: string
        type: string
        playersCountType: string
        teamAScore?: number
        teamBScore?: number
        status: string
        vsName?: string
    }
    onClick?: () => void,
    onReturn: () => void,
}

const GameListItem = ( props : GameListItemProps) => {
    const handleReturnClick = useCallback(() => {
        props.onReturn()}, [props.onReturn])

    const [openDetail, setOpenDetail] = useState(false)

    return (
        <>
            <Card
                className="game-list-item b2_r mt-12px"
                onClick={() => setOpenDetail(true)}
                sx={{ cursor: props.onClick ? "pointer" : "default" }}
            >
                <CardContent className="p-16px cl-primary-cyan01">
                    <div >
                        {/* 왼쪽 */}
                        <div className={'game-list-item-box'}>
                            <div className={'game-list-item-box-row-1'}>
                                <div>📅 {props.game.matchDt}</div>
                                <div>⏰ {props.game.time}</div>
                            </div>
                            <div className={'game-list-item-box-row-2'}>
                                <div>📍 {props.game.place}</div>
                                <div>⚔️ {props.game.type && props.game.type === '자체전'? props.game.type: props.game.vsName}</div>
                                <div>{props.game.status === '완료'? ' ⚽ ' +props.game.teamAScore + ' : '+ props.game.teamBScore : '' }</div>
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>

            <Dialog fullScreen open={openDetail} onClose={() => setOpenDetail(false)}
                    PaperProps={{
                        sx: {
                            backgroundColor: '#1A1A1A',
                            color: '#24cbaa',
                            padding: 0,

                            /* TextField */
                            '& .MuiOutlinedInput-root': {
                                color: '#24cbaa',
                                backgroundColor: '#111',
                            },

                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#24cbaa',
                            },

                            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#2fffd7',
                            },

                            '& .MuiInputLabel-root': {
                                color: '#24cbaa',
                            },

                            '& .MuiSvgIcon-root': {
                                color: '#24cbaa',
                            },

                            '& .MuiBox-root': {
                                backgroundColor: '#1A1A1A',
                                color: '#24cbaa',
                            }


                        }
                    }}>
                <GameDetail onClose={() => setOpenDetail(false)} game={props.game}  onReturn={handleReturnClick}/>
            </Dialog>
        </>
    )
}

export default GameListItem